// extracted by mini-css-extract-plugin
module.exports = {"block":"VisitCenter_block____m2W","footer":"VisitCenter_footer__VFLE7","viewAll":"VisitCenter_viewAll__X16FU","total":"VisitCenter_total___ZoCe"};